import { useEffect } from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useNotification } from '../../helpers/Notification';
import * as ROUTES from '../../router/Routes';
import { allPerfilesAction } from '../sistema/perfiles/PerfilesAction';
import { allCarnetAction } from './CarnetAction';
import { ACTIVO_CARNET, PARAMS_CARNET } from './CarnetReducer';

const useCarnetHook = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const carnetStore = Redux.useSelector((state) => state.carnet);
  const perfilesStore = Redux.useSelector((state) => state.perfiles);

  useEffect(() => {
    if (!entidadesStore.activo) {
      notify('Selecciona una entidad para entrar en módulo de carnetización', {
        warning: true,
      });
      history.push(ROUTES.entidades.to);
      return;
    }

    const fetchData = async () => {
      // Perfiles
      if (perfilesStore.all && perfilesStore.all.length === 0) {
        await allPerfilesAction(dispatch, null);
      }

      // Carnets
      if (carnetStore.all && carnetStore.all.length === 0) {
        const payload = { idEntidad: entidadesStore.activo.id };
        dispatch({ type: PARAMS_CARNET, payload });
        await allCarnetAction(dispatch, payload);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (carnetStore.stylesCarnet) {
      carnetStore.activo[carnetStore.stylesCarnet.id] =
        carnetStore.stylesCarnet.styles;
      dispatch({ type: ACTIVO_CARNET, payload: carnetStore.activo });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carnetStore.stylesCarnet]);

  return {
    entidad: entidadesStore.activo,
    perfiles: perfilesStore.all,
    activo: carnetStore.activo,
    all: carnetStore.all,
    params: carnetStore.params,
    loading: carnetStore.loadingAll,
    styles: carnetStore.stylesCarnet,
  };
};

export default useCarnetHook;
